/**
 * Arquivo: src/components/ConfirmDialog.tsx
 * Versão: 4.10.98
 * Data: 17/09/2026
 * Descrição: Confirmação visual padronizada do sistema, sem diálogos nativos do navegador.
 */
import { AlertTriangle, X } from 'lucide-react'
import { protegerAposFechamentoPorToque } from '../utils/touchInteractionGuard'

interface ConfirmDialogProps {
  aberto: boolean
  titulo?: string
  mensagem: string
  confirmarTexto?: string
  cancelarTexto?: string
  processando?: boolean
  perigo?: boolean
  onConfirmar: () => void | Promise<void>
  onCancelar: () => void
}

export default function ConfirmDialog({
  aberto,
  titulo = 'Confirmar ação',
  mensagem,
  confirmarTexto = 'Confirmar',
  cancelarTexto = 'Cancelar',
  processando = false,
  perigo = true,
  onConfirmar,
  onCancelar,
}: ConfirmDialogProps) {
  if (!aberto) return null

  return (
    <div
      className="confirm-dialog-backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget && !processando) {
          e.preventDefault()
          e.stopPropagation()
          protegerAposFechamentoPorToque(e.detail)
          onCancelar()
        }
      }}
    >
      <div
        className="confirm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="confirm-dialog-close"
          aria-label="Fechar"
          disabled={processando}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            protegerAposFechamentoPorToque(e.detail)
            onCancelar()
          }}
        >
          <X size={18} />
        </button>

        <div className={`confirm-dialog-icon ${perigo ? 'danger' : ''}`}>
          <AlertTriangle size={24} />
        </div>

        <div className="confirm-dialog-content">
          <h3 id="confirm-dialog-title">{titulo}</h3>
          <p>{mensagem}</p>
        </div>

        <div className="confirm-dialog-actions">
          <button
            type="button"
            className="button ghost"
            disabled={processando}
            onClick={onCancelar}
          >
            {cancelarTexto}
          </button>

          <button
            type="button"
            className={`button ${perigo ? 'danger-button' : 'primary'}`}
            disabled={processando}
            onClick={() => void onConfirmar()}
          >
            {processando ? 'Processando...' : confirmarTexto}
          </button>
        </div>
      </div>
    </div>
  )
}
